/**
 * Static consent options grouped by feature sets and dependency pairs.
 * Maps title, descriptions, tags, and structure exactly from legacy legal parameters.
 */
export const structuredOptionalConsents = [
  {
    featureKey: "records_and_sharing",
    heading: "Share developmental record",
    items: [
      {
        id: "opt_provider_share",
        title: "I allow Smile2Steps to share my child’s developmental record with a healthcare provider or professional I select.",
        desc: "You’ll pick the specific provider later, in the app, and share only what you select. You can stop sharing anytime.",
        tag: null
      },
      {
        id: "opt_share_health_record",
        title: "I allow secure analysis of non-identifiable growth and milestones to support health record pattern analysis.",
        desc: "Assists pediatric specialists in finding developmental similarities across anonymized trends to better support families.",
        tag: null
      }
    ]
  },
  {
    featureKey: "speech_and_audio",
    heading: "Speech & Audio",
    items: [
      {
        id: "opt_bio_audio_feature",
        title: "I agree to use voice recordings to support speech development tracking.",
        desc: "Clips are analyzed by Smile2Steps and deleted after analysis; only the developmental results are stored to track your child’s speech over time.",
        tag: "BIOMETRIC INPUT"
      },
      {
        id: "opt_train_audio",
        title: "I allow Smile2Steps to use non-identifiable information from my child’s voice data.",
        desc: "You may allow Smile2Steps to use non-identifiable information to improve the app for other families.",
        tag: "OPTIONAL"
      }
    ]
  },
  {
    featureKey: "movement_and_video",
    heading: "Movement & Video",
    items: [
      {
        id: "opt_bio_video_feature",
        title: "I agree to use video recordings to support movement and play development tracking.",
        desc: "Clips are analyzed by Smile2Steps and deleted after analysis; only the developmental results are stored to track your child’s movement and play over time.",
        tag: "BIOMETRIC INPUT"
      },
      {
        id: "opt_train_video",
        title: "I allow Smile2Steps to use non-identifiable information from my child’s video data.",
        desc: "You may allow Smile2Steps to use non-identifiable information to improve the app for other families.",
        tag: "OPTIONAL"
      }
    ]
  }
];